import React, { useEffect, useState } from 'react'
import './info.less'
import { List } from 'antd-mobile'
import { WhiteSpace } from 'antd-mobile'
import { ticketDetailApi } from '@/api/repair'
import { Toast, Modal } from 'antd-mobile'
import { cancelTicketApi } from '@/api/repair'
const Item = List.Item
const Brief = Item.Brief
const alert = Modal.alert

function Info({ id }: any) {
  const [info, setInfo]: any = useState()
  useEffect(() => {
    const fetchData = async () => {
      Toast.loading('加载中', 0)
      const { data } = await ticketDetailApi({ id })
      Toast.hide()
      if (data.code !== 'SUCCESS') {
        Toast.info(data.msg, 1.5)
        return false
      }
      setInfo(data?.data?.data)
    }
    fetchData()
  }, [id])

  //取消工单
  const requestOption = async () => {
    Toast.loading('加载中', 0)
    const { data } = await cancelTicketApi({ id })
    Toast.hide()
    if (data.code !== 'SUCCESS') {
      Toast.info(data.msg, 1)
      return
    }
    let ob = { ...info }
    ob.status = 'cancel'
    setInfo(ob)
  }
  const cancelTicket = async () => {
    alert('是否取消工单', '', [
      { text: '否' },
      { text: '是', onPress: () => requestOption() },
    ])
  }
  return (
    <div className="ticket-info">
      <div
        className="ticket-info-content"
        style={{
          height:
            info?.status === 'wait'
              ? 'calc(100vh - 45px - 0.5rem)'
              : 'calc(100vh - 45px)',
        }}
      >
        <Item
          wrap={true}
          extra={`${info?.store_name}${info?.room_no}${info?.bed_no}`}
        >
          保修地址
        </Item>
        <WhiteSpace size="lg" />
        <Item wrap={true} extra={info?.parent_type_name}>
          保修类型
        </Item>
        <Item wrap={true}>
          <span style={{ fontWeight: 600, fontSize: '0.17rem' }}>故障描述</span>
          <Brief>
            <span className="ticket-tag">{info?.type_name}</span>
          </Brief>
          <div className="ticket-describe">{info?.describe}</div>
          <Brief>
            {info?.img.map((item: string, i: number) => (
              <img className="ticket-img" key={i} src={item} alt="png" />
            ))}
          </Brief>
        </Item>
        <WhiteSpace size="lg" />
        <Item extra={info?.user_name}>报修人</Item>
        <Item extra={info?.phone}>报修电话</Item>
        <Item extra={info?.add_time}>报修时间</Item>
        <Item extra={info?.order_sn}>工号单</Item>
        <WhiteSpace size="lg" />
      </div>
      {info?.status === 'wait' && (
        <div className="ticket-info-but" onClick={cancelTicket}>
          取消工单
        </div>
      )}
    </div>
  )
}

export default Info
